import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { getPayPayPaymentStatus } from "utils/api";
import { Typography, Box } from "@mui/material";
import AppLayout from "works/chi/components/AppLayout";
import StyledButton from "works/chi/components/StyledButton";
import Loading from "default/components/Loading";
import { COLORS } from "constants/colors";

function CheckPayPayStatus() {
  const navigate = useNavigate();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);

  const soulId = queryParams.get("soul_id");
  const lng = queryParams.get("lng") || "ja";
  const merchantPaymentId = queryParams.get("merchant_payment_id");

  const [status, setStatus] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const checkStatus = async () => {
      try {
        const { status } = await getPayPayPaymentStatus(merchantPaymentId);
        if (status === "COMPLETED") {
          setStatus("COMPLETED");
        } else if (status === "CREATED") {
          setStatus("CREATED");
        } else {
          setStatus("ERROR");
        }
      } catch (error) {
        console.error("Error fetching payment status:", error);
        setStatus("ERROR");
      } finally {
        setLoading(false);
      }
    };
    checkStatus();
  }, [merchantPaymentId]);

  if (loading) {
    return (
      <AppLayout>
        <Loading />
      </AppLayout>
    );
  }

  const renderMessageAndAction = () => {
    switch (status) {
      case "CREATED":
        return {
          message: "購入が完了しておりません。\n再度購入してください。",
          buttonLabel: "購入画面へ",
          onClick: () => navigate(`/chi/tickets?soul_id=${soulId}&lng=${lng}`),
        };
      case "COMPLETED":
        return {
          message: "決済が完了しました。",
          buttonLabel: "使い方へ",
          onClick: () =>
            navigate(`/chi/how-to-use?soul_id=${soulId}&lng=${lng}`),
        };
      case "ERROR":
      default:
        return {
          message: "エラーが発生しました。",
          buttonLabel: "購入画面へ",
          onClick: () => navigate(`/chi/tickets?soul_id=${soulId}&lng=${lng}`),
        };
    }
  };

  const content = renderMessageAndAction();

  return (
    <AppLayout>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          width: "100%",
          minHeight: "100vh",
        }}
      >
        <Box
          sx={{
            width: "80%",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            backgroundColor: COLORS.BACKGROUND_WHITE,
            borderRadius: "5px",
            padding: 4,
            gap: 4,
          }}
        >
          <Typography
            variant="h4"
            sx={{
              fontSize: "18px",
              whiteSpace: "pre-line",
              fontWeight: "bold",
              textAlign: "center",
              color: COLORS.TEXT_BLACK,
              mt: 1,
            }}
          >
            {content.message}
          </Typography>

          <StyledButton
            variant="contained"
            sx={{
              width: "80%",
              color: COLORS.TEXT_BLACK,
              fontWeight: "bold",
              border: `2px solid ${COLORS.TEXT_BLACK}`,
            }}
            onClick={content.onClick}
          >
            {content.buttonLabel}
          </StyledButton>
        </Box>
      </Box>
    </AppLayout>
  );
}

export default CheckPayPayStatus;
